import script from "./tags-nav.vue?vue&type=script&setup=true&lang=js"
export * from "./tags-nav.vue?vue&type=script&setup=true&lang=js"

import "./tags-nav.vue?vue&type=style&index=0&id=7991925a&lang=scss&scoped=true"

import exportComponent from "/Users/tyk/Desktop/work/kangleiot/biz-sharingspace/sharing-space-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7991925a"]])

export default __exports__